import {UI} from "stem-core/src/ui/UIBase";
import {Messages} from "../../../Messages";
import {registerStyle, Theme} from "stem-core/src/ui/style/Theme";
import {BaseInput} from "../../../ui/Input";
import {AuthHelper} from "../../../AuthHelper";
import {styleRule, StyleSheet} from "../../../../stem-core/src/ui/Style";
import {authService} from "client/connection/Services";
import {MerchantButton} from "../../../common/MerchantButton";
import {MerchantActiveButton} from "../../../common/donate/MerchantActiveButton";
import {PanelToast} from "../../PanelToast";
import {LoadingSpinner} from "../../../ui/LoadingSpinner";


export class AccountLookupStyle extends StyleSheet {
    @styleRule
    textLink = this.themeProps.AUTH_LINK_STYLE;

    @styleRule
    signUpPanel = {
        position: "relative",
    };

    @styleRule
    inputContainer = {
        display: "flex",
    };

    inputCommon = {
        marginTop: 18,
    };

    @styleRule
    nameInput = {
        ...this.inputCommon,
        flex: 0.7,
    };

    @styleRule
    zipCodeInput = {
        ...this.inputCommon,
        marginLeft: 12,
        flex: 0.3,
    };

    @styleRule
    dividerLine = {
        marginTop: 24,
        fontSize: "15px !important",
    };

    @styleRule
    button = {
        ...Theme.props.AUTH_BUTTON_STYLE,
        margin: "14px 0",
    };

    @styleRule
    tabs = {
        width: "100%",
        display: "flex",
        ">:first-child": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
        },
        ">:last-child": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
        }
    };

    @styleRule
    tabButton = {
        flex: 1,
    }
}

const CDS_LOGIN_METHODS = {
    nameAndZip: "nameAndZip",
    accountNumber: "accountNumber",
};

@registerStyle(AccountLookupStyle)
export class AccountLookup extends UI.Element {
    activeSection = CDS_LOGIN_METHODS.accountNumber;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            inputPlaceholder: "",
        }
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.signUpPanel);
    }

    render() {
        return [
            this.getHeaderSection(),
            this.getEmailInputSection(),
        ];
    }

    getHeaderSection() {
        const {styleSheet} = this;

        return <div className={styleSheet.tabs}>
            <MerchantActiveButton className={styleSheet.tabButton} label={Messages.accountNumber}
                                  active={this.activeSection === CDS_LOGIN_METHODS.accountNumber}
                                  onClick={() => {this.activeSection = CDS_LOGIN_METHODS.accountNumber; this.redraw()}}/>
            <MerchantActiveButton className={styleSheet.tabButton} label={Messages.nameAndZip}
                                  active={this.activeSection === CDS_LOGIN_METHODS.nameAndZip}
                                  onClick={() => {this.activeSection = CDS_LOGIN_METHODS.nameAndZip; this.redraw()}}/>
        </div>
    }

    getEmailInputSection() {
        const {styleSheet} = this;
        const button = <MerchantButton label={Messages.lookUpPrintMagazineButton}
                                       className={styleSheet.button} disabled={!this.canSubmit()}
                                       onClick={() => this.handleSubmit()}/>;

        return this.activeSection === CDS_LOGIN_METHODS.nameAndZip ? [
            <div className={styleSheet.inputContainer}>
                <BaseInput ref="nameInput" label={Messages.name} className={styleSheet.nameInput}
                           onEnter={() => this.handleSubmit()} onChange={() => this.redraw()}/>
                <BaseInput ref="zipCodeInput" label={Messages.lookupPrintMagazineZipCode} className={styleSheet.zipCodeInput}
                           onEnter={() => this.handleSubmit()} onChange={() => this.redraw()}/>
            </div>,
            button
        ] : [
            <BaseInput ref="accountNumberInput" label={Messages.accountNumber} className={styleSheet.nameInput}
                        onEnter={() => this.handleSubmit()} onChange={() => this.redraw()}/>,
            button
        ]
    }

    canSubmit() {
        return this.activeSection === CDS_LOGIN_METHODS.nameAndZip ?
            this.nameInput?.getValue() && this.zipCodeInput?.getValue() : this.accountNumberInput?.getValue();
    }

    async handleSubmit() {
        if (!this.canSubmit()) {
            return;
        }
        const request = this.activeSection === CDS_LOGIN_METHODS.nameAndZip ? {
            name: this.nameInput.getValue().trim(),
            zipCode: this.zipCodeInput.getValue().trim(),
        } : {
            accountNumber: this.accountNumberInput.getValue().trim(),
        };

        LoadingSpinner.show();
        try {
            await authService.loginAtEndpoint("/external_providers/login_with_cds/", request);
        } catch (error) {
            PanelToast.showError(error.message);
        } finally {
            LoadingSpinner.hide();
        }
    }
}
